<template>
  <div id="calendar-sheet__video">
    <div class="" v-html="routedDay.videos[0].videoFile?._rendered" />
    <div
      id="calendar-sheet__video__title"
      class="video-preview-box__title text-almostBlack self-stretch grow pb-[15px] pt-[8px] pl-[13px] text-left rounded-br-[2rem]"
      :class="computedSchoolLevelBackgroundColor"
    >
      <div class="font-sans pb-[2px] text-[14px]">{{ splitTitle[0] }}</div>
      <div class="font-bree text-[15px]">{{ splitTitle[1] }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import findBySlug from "../../../../../store/getters/resolve/find-by-slug";

export default {
  name: "CalendarSheetVideo",
  computed: {
    ...mapGetters(["routedDay", "routedSchoolLevel"]),
    splitTitle() {
      const parts = this.routedDay.videos[0].title.split(":");
      return parts.length > 1
        ? [parts[0].trim(), parts[1].trim()]
        : [this.routedDay.videos[0].title];
    },
    computedSchoolLevelBackgroundColor() {
      const slug = this.routedSchoolLevel?.slug;
      if (!slug) return "";
      const bgMap = {
        onderbouw: "bg-yellow-200",
        "midden-bovenbouw": "bg-yellowGreen-200",
      };

      return bgMap[slug] || "";
    },
  },
};
</script>

<style scoped lang="css">
#calendar-sheet__video {
  @apply bg-white overflow-hidden text-center;

  & a {
    @apply no-underline w-min;
  }

  width: 199px;
  ::v-deep(iframe) {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;

    /* Very small screens :) */
    height: 112px;
    width: 100%;
  }
}

@media (min-width: 1024px) and (min-height: 768px) {
  #calendar-sheet__video {
    width: 270px;
    ::v-deep(iframe) {
      height: 152px;
    }
  }
}

@media (min-width: 1280px) and (min-height: 960px) {
  #calendar-sheet__video {
    width: 576px;
    ::v-deep(iframe) {
      height: 324px;
    }
  }
}

@media (min-width: 1600px) and (min-height: 1200px) {
  #calendar-sheet__video {
    width: 704px;
    ::v-deep(iframe) {
      height: 396px;
    }
  }
}
</style>
